import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminPlans = lazy(() => import("@/pages/admin/AdminPlans"));

export const Route = createFileRoute("/admin/elavtal")({
  component: () => <AdminPlans />,
});
